import findLast from 'lodash-es/findLast';
import uniqBy from 'lodash-es/uniqBy';
import { getNoNameFiltersData } from '@/pages/intelligence/services/filter';

const sortStorankSources = ['appstore top', 'appstore top new', 'googleplay top', 'googleplay top new'];
const sortStorankSourcesKeys = ['free', 'grossing', 'paid'];
// 获取排序后的 store rankds sources，排序规则 按照Free/Grossing/Paid，优先iOS然后Googleplay。
export function getSortedStorankSources(sources: string[]): string[] {
  if (!Array.isArray(sources)) return [];
  let result: string[] = [];
  const maxIdx = sortStorankSourcesKeys.length;

  // 按ios、googleplay分堆
  const typedSourcesMap = sources.reduce<{ [key: string]: string[] }>((acc, cur) => {
    if (typeof cur !== 'string') return acc;
    const type = findLast(sortStorankSources, (item) => cur.includes(item));
    if (!type) return acc;
    if (!Array.isArray(acc[type])) {
      acc[type] = [];
    }
    if (!acc[type].includes(cur)) {
      acc[type].push(cur);
    }
    return acc;
  }, {});

  // 对多个分堆 逐个按照 sortSourcesKeys关键字 指定的顺序 排序，没在sortSourcesKeys关键字中匹配上的排后面
  Object.keys(typedSourcesMap).forEach((item) => {
    if (Array.isArray(typedSourcesMap[item])) {
      typedSourcesMap[item].sort((a, b) => {
        let aIdx = sortStorankSourcesKeys.findIndex((subItem) => a.includes(subItem));
        let bIdx = sortStorankSourcesKeys.findIndex((subItem) => b.includes(subItem));
        aIdx = aIdx === -1 ? maxIdx : aIdx;
        bIdx = bIdx === -1 ? maxIdx : bIdx;
        return aIdx - bIdx;
      });
    }
  });

  // 对排序后的分堆 汇总
  sortStorankSources.forEach((item) => {
    result = [...result, ...(typedSourcesMap[item] || [])];
  });

  return result;
}

export function getAllMarketsValues(list: any[]): string[] {
  if (!Array.isArray(list)) return [];
  const result: string[] = [];

  for (const area of list) {
    if (!area) continue;
    const countries = area.country_set;
    if (!Array.isArray(countries)) continue;

    for (const country of countries) {
      let abbre: string;
      if (!country) continue;
      abbre = country.abbre;
      if (typeof abbre !== 'string' || !abbre.length) continue;
      abbre = abbre.toLowerCase();
      result.push(abbre);
    }
  }

  return result;
}

function getAllCountries(countrySet: any[]): any[] {
  if (!Array.isArray(countrySet)) return [];
  const countries = countrySet
    .filter((item) => item && Array.isArray(item.country_set) && item.country_set.length)
    .map((item) => item.country_set)
    .flat();
  return uniqBy(countries, 'abbre');
}

export function getAllCountriesValues(countrySet: any[]): string[] {
  const countries = getAllCountries(countrySet);
  return countries.filter((item) => item?.abbre).map((item) => item?.abbre);
}

/**
 * 根据后端返回的地区国家数据格式，返回 国家筛选器组件需要的地区国家数据格式
 * @param regionCountries 后端返回的地区国家数据
 * @returns 国家选择器组件需要的地区国家数据格式
 */
function getCountrySet(regionCountries: any[]): any[] {
  const countrySet: any[] = [];
  let countrySetTemp: any;
  let countriesTemp: any[];
  let countryItem: any;

  try {
    for (const regionCountry of regionCountries) {
      countriesTemp = [];
      for (const country of regionCountry.country_set) {
        countryItem = {
          abbre: country.abbre,
          name: country.name,
        };
        countriesTemp.push(countryItem);
      }
      countrySetTemp = {
        continent: regionCountry.continent,
        subcontinent: regionCountry.subcontinent,
        country_set: countriesTemp,
      };
      countrySet.push(countrySetTemp);
    }
  } catch (exception) {
    console.warn(exception);
  }

  return countrySet;
}

/**
 * 初始化 地区国家map（key为app商店，value为地区国家集合），地区国家组件所需地区国家集合
 * @param entityType mobile、pc、console端类型
 * @param stores app商店列表
 * @param store 初始app商店
 * @param mapSetter 地区国家map的setter方法，该map的key为 app商店，value为app商店对应的地区国家集合
 * @param setSetter 地区国家集合的setter方法，该数据提供给国家筛选器组件 作为可选数据使用
 */
export async function initCountrySetMapAndCountrySet(
  entityType: string,
  stores: string[],
  store: string,
  mapSetter: React.Dispatch<React.SetStateAction<{ [key: string]: any[] }>>,
  setSetter: React.Dispatch<React.SetStateAction<any[]>>,
  callback?: (countriesWithRegion: any[], countries: string[]) => void,
) {
  try {
    const params = {
      type: [{ tabName: entityType }],
      multiitem: stores,
    };
    const res: any = await getNoNameFiltersData(params);
    const regionCountriesStores = res?.data?.platform_region_country;
    const regionCountriesMap = regionCountriesStores.reduce(
      (current: any, next: any) => ({
        ...current,
        [next.name]: getCountrySet(next.region_country),
      }),
      {},
    );
    const countrySet = regionCountriesMap[store];
    if (mapSetter instanceof Function) {
      mapSetter(regionCountriesMap);
    }
    if (setSetter instanceof Function) {
      setSetter(countrySet);
    }
    if (callback instanceof Function) {
      const countries = getAllCountriesValues(countrySet);
      callback(countrySet, countries);
    }
  } catch (exception) {
    console.warn(exception);
  }
}
